import { cooKeys, getCookie, setCookie } from "goi_common";
import { useRouter } from "next/router";

const ONE_DAY_IN_SECONDS = 60 * 60 * 24;

const PAID_AD_CAMPAIGN_KEYWORDS = ["naver_ad", "daum_ad"];
const DOGSOUND_UTM_SOURCE = "dogsound";
const GOOGLE_BLOCKED_REFERRERS = ["syndicatedsearch.goog", "youtube", "googlequicksearchbox"];

export const useTrackCostComparisonEntry = () => {
  const router = useRouter();

  const trackEntry = () => {
    if (getCookie(cooKeys.cost_comparison_entry)) return;

    const utmCampaign =
      typeof router.query.utm_campaign === "string" ? router.query.utm_campaign : "";
    const utmSource = typeof router.query.utm_source === "string" ? router.query.utm_source : "";
    const utmTerm = typeof router.query.utm_term === "string" ? router.query.utm_term : "";
    const gclid = typeof router.query.gclid === "string" ? router.query.gclid : "";
    const referrer = typeof document !== "undefined" ? document.referrer : "";

    const isNaverOrDaumAd = PAID_AD_CAMPAIGN_KEYWORDS.some((keyword) =>
      utmCampaign.includes(keyword),
    );
    const isGoogleAd =
      !!utmTerm &&
      !!gclid &&
      !GOOGLE_BLOCKED_REFERRERS.some((blocked) => referrer.includes(blocked));
    const isDogsound = utmSource === DOGSOUND_UTM_SOURCE;

    if (isNaverOrDaumAd || isGoogleAd || isDogsound) {
      setCookie(cooKeys.cost_comparison_entry, "true", ONE_DAY_IN_SECONDS);
    }
  };

  return { trackEntry };
};
